const API_ADD_TEAM_LEADER_REQUEST = 'API_ADD_TEAM_LEADER_REQUEST';
const API_ADD_TEAM_LEADER_SUCCESS = 'API_ADD_TEAM_LEADER_SUCCESS';
const API_ADD_TEAM_LEADER_FAILURE = 'API_ADD_TEAM_LEADER_FAILURE';

export const addTeamLeaderRequest = () => ({
  type: API_ADD_TEAM_LEADER_REQUEST,
});

export const addTeamLeaderSuccess = payload => ({
  type: API_ADD_TEAM_LEADER_SUCCESS,
  payload,
});

export const addTeamLeaderFailure = payload => ({
  type: API_ADD_TEAM_LEADER_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
};

export function addTeamLeaderReducer(state = initialState, action) {
  switch (action.type) {
    case API_ADD_TEAM_LEADER_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_ADD_TEAM_LEADER_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
      };
    case API_ADD_TEAM_LEADER_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
      };
    default:
      return state;
  }
}
